export default "__VITE_ASSET__DoBDBYj7__"